import { render, staticRenderFns } from "./DetalhesOrganizacao.vue?vue&type=template&id=03a37878&"
import script from "./DetalhesOrganizacao.vue?vue&type=script&lang=js&"
export * from "./DetalhesOrganizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports